// extracted by css-extract-rspack-plugin
export default {"root":"rfmJsTSDYdQRrISV","shape":"ILxfuEBTKIbzdnPQ","thinking-breathe":"dWSlNVPGOewWH4OC"};